import {type FunctionalComponent, h, type VNode} from '@stencil/core';

import {GuidedKeywordSuggestionItem} from '../../models/quick-link';
import type {GuidedV2Emitters} from '../../models/eventNames';
import { ChipType } from '../chips-carousel/model';

export interface SuggestionsBarParams {
  results: GuidedKeywordSuggestionItem[];
  // searchTerm: string;
  label: string;
  eventEmitters: GuidedV2Emitters;
  isMobile?: boolean;
}
export const SuggestionsBar: FunctionalComponent<SuggestionsBarParams> = (params: SuggestionsBarParams)=>{
    const {
      results,
      // searchTerm,
      label,
      eventEmitters,
      isMobile
    } = params;
    const terms = results.map(r=>r.keywordSuggestion);

    return <div class="guided-v2-subcomponent-suggestions-bar">
      <uiaas-guided-v2-chips-carousel class="add-selector-strength"
        header={label}
        terms={terms}
        chipType={ChipType.GuidedV2Suggestions}
        chipClickedSourceType={'suggestions'}
        maxDesktopTagLength={30}
        maxMobileTagLength={20}
        isMobile={isMobile}
      ></uiaas-guided-v2-chips-carousel>
    </div> as VNode;
};
